import { toPng } from "html-to-image";
import jsPDF from "jspdf";

function slugCampus(campusName) {
  return String(campusName || "campus")
    .trim()
    .replace(/[^a-z0-9]+/gi, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase();
}

/**
 * Export the daily summary as a PDF that mirrors the on-screen preview: each
 * day's "summary sheet" DOM node is captured to an image and placed on its own
 * page (sliced across pages if a single day is taller than one page).
 *
 * @param {NodeList|Array<HTMLElement>} nodes - the `.summary-sheet` elements
 * @param {string} campusName
 */
export async function exportDailySummaryPdf(nodes, campusName) {
  const sheets = Array.from(nodes || []);
  if (sheets.length === 0) return;

  const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const margin = 24;
  const maxW = pageW - margin * 2;
  const usableH = pageH - margin * 2;

  for (let i = 0; i < sheets.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    const dataUrl = await toPng(sheets[i], {
      backgroundColor: "#ffffff",
      pixelRatio: 2,
    });

    const props = doc.getImageProperties(dataUrl);
    const imgW = maxW;
    const imgH = (props.height * imgW) / props.width;

    if (i > 0) doc.addPage();

    // First page of this sheet.
    doc.addImage(dataUrl, "PNG", margin, margin, imgW, imgH);

    // If the sheet is taller than one page, draw it again shifted up so the
    // remainder spills onto subsequent pages (viewers clip to the page).
    let renderedH = usableH;
    while (renderedH < imgH) {
      doc.addPage();
      doc.addImage(dataUrl, "PNG", margin, margin - renderedH, imgW, imgH);
      renderedH += usableH;
    }
  }

  doc.save(`daily_summary_${slugCampus(campusName)}.pdf`);
}
